import React from 'react';
import { LogoYamaha, LogoYamahaBlack, LogoYamahaWhite } from '@yme/assets/icons';
import { SVG } from '@yme/atoms/svg-icon';
import { FlexLinkStyled } from '@yme/molecules/buttons';
import { useTranslation } from '@yme/services/i18n';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
import { DefaultLogoStyled, LogoFooterStyled, LogoHeaderStyled, LogoLinkHeaderStyled, } from './LogoStyled';
import { LOCATION_FOOTER, LOCATION_HEADER } from './types';
// TODO: Need re-implement this component for support Default Type of logotype
function DefaultLogo() {
    return (React.createElement(DefaultLogoStyled, null,
        React.createElement(SVG, { src: LogoYamaha })));
}
function LogoHeader({ logoLink, ariaLabel, onClick }) {
    if (logoLink) {
        return (React.createElement(LogoLinkHeaderStyled, { to: {
                pathname: logoLink,
            }, "aria-label": ariaLabel, onClick: onClick },
            React.createElement(LogoHeaderStyled, null,
                React.createElement(SVG, { src: LogoYamahaBlack }))));
    }
    return (React.createElement(LogoHeaderStyled, null,
        React.createElement(SVG, { src: LogoYamahaBlack })));
}
function LogoFooter({ logoLink, ariaLabel }) {
    const component = (React.createElement(LogoFooterStyled, null,
        React.createElement(SVG, { src: LogoYamahaWhite })));
    if (logoLink) {
        return (React.createElement(FlexLinkStyled, { to: logoLink, "aria-label": ariaLabel }, component));
    }
    return component;
}
export function Logo({ locationType, logoLink }) {
    const { t } = useTranslation();
    const handleClick = () => {
        setDigitalData(DigitalDataMutation.NAVIGATION, {
            pageSection: '',
            navigationGroup: '',
            navigationItem: 'home_button',
        });
    };
    switch (locationType) {
        case LOCATION_HEADER:
            return LogoHeader({
                logoLink,
                ariaLabel: t('common_homepage_accessibility'),
                onClick: handleClick,
            });
        case LOCATION_FOOTER:
            return LogoFooter({
                logoLink,
                ariaLabel: t('common_homepage_accessibility'),
            });
        default:
            return DefaultLogo();
    }
}
